module.exports = __webpack_public_path__ + "images/category_lp/pc/lp-pc-shop-image5_b33f0c127f37b6d6c93dae14c51d8bbc.png";